import { useOneClick } from 'contexts/OneClickBuyContext';
import { getPaymentMethodOptions } from 'helpers/offerPaymentMethods';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Container, MethodItem, MethodList, UsedBefore } from './styles';

const PaymentMethodList: React.FC = () => {
	const {
		allowedPaymentMethods,
		highlightedPaymentMethod,
		selectedPaymentMethod,
		selectPaymentMethod,
		isChoosingPaymentMethod,
	} = useOneClick();
	const { t } = useTranslation('upsell');

	if (!isChoosingPaymentMethod) return null;

	const options = getPaymentMethodOptions(allowedPaymentMethods, highlightedPaymentMethod);

	if (!options.length) {
		return (
			<Container>
				<p>{String(t('paymentMethods.unavailable'))}</p>
			</Container>
		);
	}

	return (
		<Container>
			<p>{String(t('paymentMethods.title'))}</p>
			<MethodList role='radiogroup'>
				{options.map(method => (
					<MethodItem
						key={method}
						type='button'
						role='radio'
						aria-checked={selectedPaymentMethod === method}
						$selected={selectedPaymentMethod === method}
						onClick={() => selectPaymentMethod(method)}
					>
						<strong>{String(t(`paymentMethods.${method}`))}</strong>
						{highlightedPaymentMethod === method ? (
							<UsedBefore>{String(t('paymentMethods.usedBefore'))}</UsedBefore>
						) : (
							<span />
						)}
						<Checkbox $checked={selectedPaymentMethod === method} />
					</MethodItem>
				))}
			</MethodList>
		</Container>
	);
};

export default PaymentMethodList;
